module.exports = __webpack_public_path__ + "static/media/pig-yellow.64b38c59.webp";